module.exports = __webpack_public_path__ + "img/ai.96e24e9.svg";